export default {

    init: function () {
        this.bindEvents();
    },

    bindEvents: function () {
        let itemsPerPage = 8;
        let target = $('.single-author-recent-posts .partial-single-card');
        let totalItems = target.length;
        let visibleItems = 0;

        target.slice(0, itemsPerPage).addClass('visible');
        visibleItems = itemsPerPage;

        $('#load-more').click(function (e) {
            e.preventDefault();
            visibleItems += itemsPerPage;
            target.slice(0, visibleItems).addClass('visible');

            if (visibleItems >= totalItems) {
                $(this).hide();
            }
        });

    },
};